import * as React from "react";

export const LevelFour = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <circle cx={22} cy={22} r={22} fill="#169FED" />
    <path
      fill="#fff"
      d="M34.813 22.28c0 6.922-5.61 12.533-12.532 12.533S9.748 29.202 9.748 22.28c0-6.921 5.611-12.532 12.533-12.532 6.921 0 12.532 5.61 12.532 12.532Zm-21.751 0a9.219 9.219 0 1 0 18.437 0 9.219 9.219 0 0 0-18.437 0Z"
    />
    <path
      fill="#fff"
      d="M23.847 22.672a1.958 1.958 0 1 1-3.916 0 1.958 1.958 0 0 1 3.916 0Z"
    />
  </svg>
);
